import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from "@ngx-translate/core";
import { BottomNavigationComponent } from './bottom-navigation/bottom-navigation.component';
import { PreConfigurationModalComponent } from './pre-configuration-modal/pre-configuration-modal.component';
import { EditWindowTypeComponent } from './edit-window-type/edit-window-type.component';
import { EditWindowDetailsComponent } from './edit-window-details/edit-window-details.component';
import { EditGlassComponent } from './edit-glass/edit-glass.component';
import { EditGeorgianBarsComponent } from './edit-georgian-bars/edit-georgian-bars.component';
import { EditGeorgianBarTypesComponent } from './edit-georgian-bar-types/edit-georgian-bar-types.component';
import { GlassInfoModalComponent } from './glass-info-modal/glass-info-modal.component';
import { GlassBybrandResultComponent } from './glass-bybrand-result/glass-bybrand-result.component';
import { EditGlassListComponent } from './edit-glass-list/edit-glass-list.component';
import { EditFrameComponent } from './edit-frame/edit-frame.component';
import { FrameProfilesModalComponent } from './frame-profiles-modal/frame-profiles-modal.component';
import { EditGeorgianBarConfigComponent } from './edit-georgian-bar-config/edit-georgian-bar-config.component';
import { ActionComponent } from './action/action.component';
import { ActionDetailsComponent } from './action-details/action-details.component';
import { HeaderComponent } from './header/header.component';
import { ComfortCalculatorComponent } from './comfort-calculator/comfort-calculator.component';
import { EnergySavingsCalculatorComponent } from './energy-savings-calculator/energy-savings-calculator.component';
import { WindowEnergyRatingsComponent } from './window-energy-ratings/window-energy-ratings.component';
import { WindowEnergyRatingDetailsComponent } from './window-energy-rating-details/window-energy-rating-details.component';
import { SWSAirSimulationComponent } from './swsair-simulation/swsair-simulation.component';
import { ElevatedTransportComponent } from './elevated-transport/elevated-transport.component';
import { LifetimeSwsAirComponent } from './lifetime-sws-air/lifetime-sws-air.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { BasicDataEnergySavingsComponent } from './basic-data-energy-savings/basic-data-energy-savings.component';
import { SavePdfModalComponent } from './save-pdf-modal/save-pdf-modal.component';
import { EditSpacerComponent } from './edit-spacer/edit-spacer.component';
import { MasterdataApiService } from '../services/masterdata-api.service';
import { UnsavedConfigurationModalComponent } from './unsaved-configuration-modal/unsaved-configuration-modal.component';
import { GlassFilterModalComponent } from './glass-filter-modal/glass-filter-modal.component';
import { AgreementModalComponent } from './agreement-modal/agreement-modal.component';
import { AppInfoModalComponent } from './app-info-modal/app-info-modal.component';
import { RatingAgreementModalComponent } from './rating-agreement-modal/rating-agreement-modal.component';
import { SystemSelectPopoverComponent } from './system-select-popover/system-select-popover.component';

@NgModule({
  imports: [
    CommonModule, FormsModule, IonicModule,
    TranslateModule.forChild()
  ],
  declarations: [BottomNavigationComponent,
    PreConfigurationModalComponent,
    EditWindowTypeComponent,
    EditWindowDetailsComponent,
    EditSpacerComponent,
    EditGlassComponent,
    EditGeorgianBarsComponent,
    EditGeorgianBarTypesComponent,
    GlassInfoModalComponent,
    GlassBybrandResultComponent,
    EditGlassListComponent,
    EditFrameComponent,
    FrameProfilesModalComponent,
    EditGeorgianBarConfigComponent,
    ActionComponent,
    ActionDetailsComponent,
    HeaderComponent,
    ComfortCalculatorComponent,
    EnergySavingsCalculatorComponent,
    WindowEnergyRatingsComponent,
    WindowEnergyRatingDetailsComponent,
    SWSAirSimulationComponent,
    ElevatedTransportComponent,
    LifetimeSwsAirComponent,
    ImageModalComponent,
    BasicDataEnergySavingsComponent,
    SavePdfModalComponent,
    UnsavedConfigurationModalComponent,
    GlassFilterModalComponent,
    AgreementModalComponent,
    AppInfoModalComponent,
    RatingAgreementModalComponent,
    SystemSelectPopoverComponent
  ],
  exports: [BottomNavigationComponent,
    EditWindowTypeComponent,
    EditWindowDetailsComponent,
    EditSpacerComponent,
    EditGlassComponent,
    EditGeorgianBarsComponent,
    EditGeorgianBarTypesComponent,
    GlassInfoModalComponent,
    GlassBybrandResultComponent,
    EditGlassListComponent,
    EditFrameComponent,
    FrameProfilesModalComponent,
    EditGeorgianBarConfigComponent,
    ActionComponent,
    ActionDetailsComponent,
    HeaderComponent,
    ComfortCalculatorComponent,
    EnergySavingsCalculatorComponent,
    WindowEnergyRatingsComponent,
    WindowEnergyRatingDetailsComponent,
    SWSAirSimulationComponent,
    ElevatedTransportComponent,
    LifetimeSwsAirComponent,
    ImageModalComponent,
    BasicDataEnergySavingsComponent,
    SavePdfModalComponent,
    GlassFilterModalComponent,
    AgreementModalComponent,
    AppInfoModalComponent,
    RatingAgreementModalComponent,
    SystemSelectPopoverComponent
  ],
  providers: [MasterdataApiService]
})
export class ComponentsModule { }
